<div class="map-marker-card-details-container" *transloco="let t">
  <div class="map-marker-card-details-body">
    <lib-campaign-card-sentence-merchant [campaign]="campaign()"  [size]="Size.SMALL"></lib-campaign-card-sentence-merchant>

    <app-loyalty-campaign-card-promo-details [campaign]="campaign()" [lightFont]="true" ></app-loyalty-campaign-card-promo-details>
  </div>

  <div class="loyalty-buttons-container">
    <div (click)="openMapApp(address().latitude, address().longitude)">
      {{ t('actions.card.newActionPreviewDetails.buttons.getDirections') }}
    </div>
    <div class="loyalty" (click)="openHowToRedeem()">
      <lib-loyalty-radial-bar [loyaltyScore]="campaign().userLoyalty.loyaltyScore"
                             [loyaltyLevel]="campaign().userLoyalty.level"
                             [size]="Size.BIG"></lib-loyalty-radial-bar>
      <div>{{ t('loyaltyLevels.' + campaign().userLoyalty.level) + ' ' +  campaign().userLoyalty.loyaltyScore}}</div>
    </div>
  </div>

</div>
